module.exports = __webpack_public_path__ + "img/cure.a5fe17ee.png";